import React, { Component } from "react";
import { LinkTo } from '../../../PageLayout/Link/Link';
import PropTypes from 'prop-types';
import Table from '../../../PageLayout/Table';
import ProjectRequestService from '../../../Services/ProjectRequestService';

class ProjectRequestCreationList extends Component {
  static propTypes = {
    projectCreationRequests: PropTypes.array.isRequired,
    cancelable: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      projectCreationRequests: this.props.projectCreationRequests,
    };
  }

  cancelProjectCreationRequest = (event, projectRequest, i) => {
    ProjectRequestService.cancelRequest(projectRequest, null, () => {
      let request = [...this.state.projectCreationRequests];
      request.splice(i, 1);

      this.setState({
        projectCreationRequests: request,
      });
    });
    event.preventDefault();
    event.stopPropagation();
  }

  render() {
    let childs = this.state.projectCreationRequests.map((projectCreationRequest, i) => {
      let owner = projectCreationRequest.projectCreationRequestUsers.find(u => { return u.profileTypeRefId == 'ADMIN'; }).user;

      return ({
        rowProps: LinkTo(`/project/request/${projectCreationRequest.projectCreationRequestId}`),
        cells: [
          projectCreationRequest.shortName,
          projectCreationRequest.description,
          projectCreationRequest.costcenterRef.costcenterRefDescription,
          (owner.firstName + ' ' + owner.lastName),
          projectCreationRequest.projectCreationRequestStatusId,
          ( this.props.cancelable && projectCreationRequest.projectCreationRequestStatusId === "REQUESTED" ? (
              <i className="icon-trash" onClick={(e) => this.cancelProjectCreationRequest(e, projectCreationRequest, i)} />
            ) : null
          ),
        ],
      });
    });

    return (
      <div className='projectRequestCreationList'>
        { childs.length > 0 &&
        <Table
          header={[
            {size: '14.7%', content: 'Short Name'},
            {size: true, content: 'Description'},
            {size: '16.9%', content: 'Cost Center'},
            {size: '17.4%', content: 'Owner'},
            {size: '17.4%', content: 'Status'},
            {size: '5.4%', content: ''},
          ]}
          rows={childs}
        />
        }
      </div>
    );
  }
}

export default ProjectRequestCreationList;
